// import axios from 'axios';
// const http = axios.create();
// http.defaults.baseURL = process.env.REACT_APP_API_URL;
// const token = localStorage.getItem('token') || '';
// console.log('token', token);

// http.defaults.headers['Authorization'] = `Token ${token}`;

// http.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response.status === 401 || error.response.status === 403) {
//             localStorage.clear();
//             window.location.href = '/';
//         }
//         return Promise.reject(error);
// });
// export default http;


import axios from 'axios';

const http = axios.create();

// Set the base URL from environment variable
http.defaults.baseURL = process.env.REACT_APP_API_URL;

// Function to update the Authorization header
export const updateAuthorizationHeader = () => {
  const token = localStorage.getItem('token');
  if (token) {
    http.defaults.headers['Authorization'] = `Token ${token}`;
  } else {
    delete http.defaults.headers['Authorization']; // Remove header if no token
  }
};

// Initial header setup
updateAuthorizationHeader();

// Add request interceptor to refresh the token on each request
http.interceptors.request.use(
  (config) => {
    updateAuthorizationHeader(); // Ensure the latest token is used
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        localStorage.clear();
        console.log('Session expired or unauthorized. Redirecting to login.');
        window.location.href = '/auth/login'; // Redirect to login page
      }
    }
    return Promise.reject(error);
  }
);

export default http;